var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[_vm.buttonClass, { 'inactive': _vm.disabled }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("svg"),(!_vm.small)?_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.buttonText))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }